import React from "react";
import Modal from "../Modal";
import ClosingX from "../ClosingX";
import UploadProgressPanel from "./UploadProgressPanel.jsx";
import { useUploadSession } from "../../context/UploadManagerContext";
import "../../css/UploadDetailsModal.css";

/**
 * UploadDetailsModal — opens the full UploadProgressPanel for one session from
 * the floating tray. `onClose` just dismisses the modal; the session keeps
 * running in the manager (and reappears in the tray) unless the user dismisses
 * it from the panel.
 */
const UploadDetailsModal = ({ sessionId, onClose }) => {
    const session = useUploadSession(sessionId);
    return (
        <Modal className="uploadDetailsModal modal--chrome" onClose={onClose} aria-labelledby="udm-modal-title">
            <div className="modal-header">
                <h1 id="udm-modal-title">{session?.title || "Upload"}</h1>
                <ClosingX onClick={onClose} />
            </div>
            <div className="modal-body udm-body">
                <UploadProgressPanel sessionId={sessionId} onClose={onClose} />
            </div>
        </Modal>
    );
};

export default UploadDetailsModal;
